/* Indicador animado de las pestañas de producto */
(() => {
  const initializedMenus = new WeakSet();

  function initializeIndicators() {
    document.querySelectorAll('.tabs-menu-product').forEach((menu) => {
      if (initializedMenus.has(menu)) return;
      initializedMenus.add(menu);

      let frame;

      function updateIndicator() {
        const activeTab = menu.querySelector('.tab-link.active');

        if (!activeTab || !menu.getClientRects().length) return;

        /* Medir el texto, no el ancho completo de la pestaña */
        const range = document.createRange();
        range.selectNodeContents(activeTab);

        const textRect = range.getBoundingClientRect();
        const menuRect = menu.getBoundingClientRect();
        const tabRect = activeTab.getBoundingClientRect();

        if (!textRect.width) return;

        const x =
          textRect.left - menuRect.left - menu.clientLeft + menu.scrollLeft;

        const y =
          tabRect.bottom - menuRect.top - menu.clientTop
          + menu.scrollTop - 3;

        menu.style.setProperty('--tab-indicator-x', `${x}px`);
        menu.style.setProperty(
          '--tab-indicator-width',
          `${textRect.width}px`
        );
        menu.style.setProperty('--tab-indicator-y', `${y}px`);
        menu.style.setProperty('--tab-indicator-visible', '1');

        /* Evitar un desplazamiento desde cero al cargar */
        if (!menu.classList.contains('has-tab-indicator')) {
          void menu.offsetWidth;
          menu.classList.add('has-tab-indicator');
        }
      }

      function scheduleUpdate() {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(updateIndicator);
      }

      /* Seguir la selección que realiza el código existente */
      const observer = new MutationObserver((mutations) => {
        if (mutations.some((mutation) =>
          mutation.target.matches('.tab-link')
        )) {
          scheduleUpdate();
        }
      });

      observer.observe(menu, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });

      const resizeObserver = new ResizeObserver(scheduleUpdate);
      resizeObserver.observe(menu);

      menu.querySelectorAll('.tab-link').forEach((tab) => {
        resizeObserver.observe(tab);
      });

      if (document.fonts) {
        document.fonts.ready.then(scheduleUpdate);
      }

      scheduleUpdate();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeIndicators,
      { once: true }
    );
  } else {
    initializeIndicators();
  }

  document.addEventListener('shopify:section:load', initializeIndicators);
})();